import { appStatusStore } from '@/stores'
import { useRef } from '@codeleap/hooks'

export function useToggleDevMode() {
  const isDevMode = appStatusStore.state.use(state => state.isDev)
  const numberOfPressesRef = useRef(0)

  function onChangePresses() {
    const newValue = numberOfPressesRef.current + 1

    if (newValue >= 10) {
      numberOfPressesRef.current = 0
      appStatusStore.toggleDevMode()
    } else {
      numberOfPressesRef.current = newValue
    }
  }

  return {
    onPress: onChangePresses,
    isDevMode,
  }
}